import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccess, getDefaultHome } from '../utils/roleAccess';

const ProtectedRoute = ({ isAuthenticated, children }) => {
  const { currentRole } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (!canAccess(currentRole, location.pathname)) {
    return <Navigate to={getDefaultHome(currentRole)} replace />;
  }

  return children;
};

export default ProtectedRoute;
